import { render, staticRenderFns } from "./BiddingList.vue?vue&type=template&id=1f0590a9&scoped=true&"
import script from "./BiddingList.vue?vue&type=script&lang=js&"
export * from "./BiddingList.vue?vue&type=script&lang=js&"
import style0 from "./BiddingList.vue?vue&type=style&index=0&id=1f0590a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0590a9",
  null
  
)

export default component.exports